<template>
  <v-card class="plan-card">
    <v-card-title class="title">
      改革プラン{{plan.no}}
    </v-card-title>
    <v-card-text>
      <v-layout align-start justify-start row>

        <v-flex sm9>
          <v-text-field v-model="plan.plan" label="改革プラン" placeholder="現状◯◯であるが〜〜のように変化する" clearable></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex sm2>
          <v-alert :value="!plan.approve_status" color="warning" icon="priority_high" outline>
            上司未承認
          </v-alert>
          <v-alert :value="plan.approve_status" color="success" icon="check_circle" outline>
            上司承認済
          </v-alert>
        </v-flex>
      </v-layout>
      <v-layout align-start justify-start row>

        <v-flex xs12 md10>
          <v-text-field v-model="plan.method" label="具体的な施策" clearable></v-text-field>
        </v-flex>
        <v-flex xs4 md2>
          <v-btn @click="updatePlan()">保存</v-btn>
        </v-flex>
      </v-layout>
      <v-flex xs12 sm11>
        <v-card class="approve-card">
          <v-card-text>
            <v-container grid-list-md>
              <h3>上司承認</h3>
              <v-layout align-start justify-start row>
                <v-flex xs12 md12>
                  <v-textarea row='3' v-model="plan.approve_comment" :readonly="bossOK" label="コメント"></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn v-show="!bossOK" @click="plan.approve_status = false; updatePlan()">差戻</v-btn>
            <v-btn v-show="!bossOK" @click="plan.approve_status = true; updatePlan()">承認</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 sm11>
        <v-card class="rate-card">
          <v-card-text>
            <v-container grid-list-md>
              <v-layout align-center justify-start row>
                <v-flex md2 class="evaluation">
                  <h3>本人評価：</h3>
                </v-flex>
                <v-flex xs3 sm1>
                  <v-select :items="selectItems" box id="self" v-model="plan.self" />
                </v-flex>
              </v-layout>
              <v-layout align-start justify-start row>
                <v-flex xs12 md12>
                  <v-textarea row='3' v-model="plan.self_comment" :readonly="bossOK" label="コメント"></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn v-show="!bossOK" @click="bossOK = true; updatePlan()">保存</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 sm11>
        <v-card class="rate-card">
          <v-card-text>
            <v-container grid-list-md>
              <v-layout align-center justify-start row>
                <v-flex md2 class="evaluation">
                  <h3>上司評価：</h3>
                </v-flex>
                <v-flex xs3 sm1>
                  <v-select :items="selectItems" box id="self" v-model="plan.reater" />
                </v-flex>
              </v-layout>
              <v-layout align-start justify-start row>
                <v-flex xs12 md12>
                  <v-textarea row='3' :readonly="bossOK" label="コメント" v-model="plan.reater_comment"></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn v-show="!bossOK" @click="bossOK = true; updatePlan()">保存</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-card-text>
  </v-card>

</template>

<script>
import db from '@/components/firebaseInit'
export default {
  components: {
  },
  props: {
    plan:{
      type:Object,
      default:{}
    },
    mode: {
      type: String,
      default: "user"
    },
},
  data() {
    return {
      bossOK: false,
      selectItems: ["◎", "◯", "△", "×"],
      dbRef: db.collection("companies").doc(this.$route.params.company_id).collection("challenge_sheets").doc(this.$route.params.sheet_id).collection('plans')
    }
  },
  computed: {


  },
  methods: {
    updatePlan() {
      this.$emit('updatePlan')
    }
  }
}
</script>

<style lang="scss" scoped>
.plan-card {
  margin-top: 5px;
}
.point {
  padding: 0px 5px;
}
.rating-card {
  margin: 0px 5px;
}
.point-label {
  margin-top: 18px;
}
.title {
  background-color: #00bcd4;
  color: white;
}
.evaluation {
  text-align: right;
  margin-bottom: 15px;
}
.rate-card,
.approve-card {
  margin-bottom: 10px;
}
</style>


